export type MissionSummaryIndustryPresentation = Readonly<{
  icon: "home" | "building" | "wrench" | "tractor" | "zap" | "lock" | "events" | "camera" | "map" | "plus";
  color: string;
}>;

const defaultPresentation: MissionSummaryIndustryPresentation = {
  icon: "plus",
  color: "#6b7280",
};

const presentationByIndustryKey: Readonly<Record<string, MissionSummaryIndustryPresentation>> = {
  real_estate: { icon: "home", color: "#2563eb" },
  construction: { icon: "building", color: "#f97316" },
  infrastructure: { icon: "wrench", color: "#6366f1" },
  agriculture: { icon: "tractor", color: "#10b981" },
  energy: { icon: "zap", color: "#fbbf24" },
  public_safety: { icon: "lock", color: "#ef4444" },
  security: { icon: "lock", color: "#ef4444" },
  film_media: { icon: "camera", color: "#a855f7" },
  film_and_media: { icon: "camera", color: "#a855f7" },
  events: { icon: "events", color: "#a855f7" },
  surveying_mapping: { icon: "map", color: "#0ea5e9" },
  surveying_and_mapping: { icon: "map", color: "#0ea5e9" },
  environmental: { icon: "tractor", color: "#10b981" },
  other: { icon: "plus", color: "#6b7280" },
};

function normalizeIndustryKey(industryLabel: string): string {
  return industryLabel
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
}

export function resolveMissionSummaryIndustryPresentation(
  industryLabel: string,
): MissionSummaryIndustryPresentation {
  const normalized = normalizeIndustryKey(industryLabel);
  return presentationByIndustryKey[normalized] ?? defaultPresentation;
}
